import "./layout/layout";
import "./layout/animation";
import "./layout/overlay";
import "./layout/carousel";
import "./layout/subscribe";
import "./pages/homepage";
import "./pages/exhibitions";
import "./pages/virtual-tour";
// import './pages/visit';
import "./layout/scrollToSection";
import "./layout/scrollSpy";
import "./layout/notice-overlay";
import "./layout/featuredItems";
import "./layout/eventSubscribe";
import "./layout/captivityCounter";
import './components/jsPosts';
import './components/customSelect'